import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = hash?.split("session_id=")[1]?.split("&")[0];

    if (!sessionId) {
      navigate("/admin/login");
      return;
    }

    // Exchange session_id for JWT
    axios.post(`${API}/auth/google-session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        // Clear hash and go to admin gallery
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin/gallery", { state: { user: res.data } });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail;
        const msg = typeof detail === "string" ? detail : "Google sign-in failed";
        navigate("/admin/login", { state: { error: msg } });
      });
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-gold mx-auto mb-4" />
        <p className="text-white/60 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
